import { useState } from 'react';
import { cx } from '@emotion/css';
import { useMotionValueEvent, useScroll } from 'framer-motion';

import { containerQueryValues } from '@phoenix/design-system/frontend/ui/breakpoints/breakpoints';

import { useNavigation } from './context/navigation-context-provider';
import { TopBar } from './components/topbar';
import { HorizontalNavigation } from './components/horizontal-navigation';

const TOP_BAR_MOBILE_HEIGHT_PX = 50;
const HORIZONTAL_NAVIGATION_MOBILE_HEIGHT_PX = 38;

export const NavigationWrapper = ({ topOffset, children }) => {
  const { scrollY } = useScroll();
  const [hide, setHide] = useState(false);

  const {
    config,
    state: { showMobileMenu },
  } = useNavigation();

  const showHorizontalNavigation = !config.shouldHideMainNavOnDesktop && (config.mainNavItems?.length || config.name);

  const navigationBarHeight = showHorizontalNavigation
    ? TOP_BAR_MOBILE_HEIGHT_PX + HORIZONTAL_NAVIGATION_MOBILE_HEIGHT_PX + topOffset
    : TOP_BAR_MOBILE_HEIGHT_PX + topOffset;

  useMotionValueEvent(scrollY, 'change', (scrollPosition) => {
    if (window.innerWidth <= containerQueryValues.tablet) {
      const isScrollingDown = scrollPosition > scrollY.getPrevious();
      setHide(isScrollingDown && scrollPosition > navigationBarHeight);
    }
  });

  return (
    <div
      className={cx(
        'transition-translate top-0 z-40 w-full duration-300',
        hide ? '-translate-y-full' : 'translate-y-0',
        showMobileMenu ? 'fixed' : 'sticky'
      )}
      data-testid="navigation"
    >
      <TopBar testIdNamespace="navigation">{children}</TopBar>
      {showHorizontalNavigation && <HorizontalNavigation />}
    </div>
  );
};
